import { TimelineMax } from '@/vendor';
import Ball from './Ball';

export default class Snowball extends Ball
{
    constructor( settings )
    {
        super( settings );

        this.name = 'snowball';

        this.sprite.x = 0;
        this.sprite.y = 0;
        this.sprite.cacheAsBitmap = false;

        this.sprite.width = 55;
        this.sprite.height = 69;

        let texture = PIXI.loader.resources[ 'snowball' ].texture;
        this.sprite.texture = texture;

        this.testGraphic.scale.x = this.testGraphic.scale.y = 1.05;

        this.sprite.cacheAsBitmap = true;

        this.pos.x = this.sprite.x = settings.x;
        this.pos.y = this.sprite.y = settings.y;

        this.testGraphic.alpha = 0;
    }

    onClick( e )
    {
        this.eventHub.emit( 'snowballSuicide' + this.id, this );
    }

    beforeDestroy()
    {
        return new Promise( resolve =>
        {
            let tl = new TimelineMax({ onComplete: resolve, delay: 1 });
            tl.to( this.sprite, 0.3, { alpha: 0 }, 0 );
        });
    }

    fancyDeathAnim()
    {
        return new Promise( resolve =>
        {
            let tl = new TimelineMax({ onComplete: resolve });
            tl.to( this.sprite, 0.2, { alpha: 0, width: '+=10', height: '+=10', y: '-=10' }, 0 );
        });
    }

    async fancyRemove()
    {
        this.sprite.interactive = false;
        await this.fancyDeathAnim();
    }
}



// WEBPACK FOOTER //
// ./src/app/game/elements/Snowball.js